import Home from '../components/pages/Home';
import Services from '../components/pages/Services';
import AboutUs from '../components/pages/AboutUs';
import Contacts from '../components/pages/Contacts';
import MainLayout from '../layouts/MainLayout';

const routesConfig = {
  services: {
    path: '/services',
    element: Services,
    layout: MainLayout
  },
  aboutUs: {
    path: '/about-us',
    element: AboutUs,
    layout: MainLayout
  },
  contacts: {
    path: '/contacts',
    element: Contacts,
    layout: MainLayout
  },
  homePage: {
    path: '/*',
    element: Home,
    layout: MainLayout
  },
};

export default routesConfig;
